export default __webpack_public_path__ + "static/media/user.344b8d88.png";